import { RouterProvider } from 'react-router-dom';

import { AppProviders } from '@/app/providers';
import { router } from '@/app/router';

/**
 * Composición raíz del **portal del cliente**.
 *
 * Es una aplicación independiente del panel: no monta el armazón de módulos,
 * permisos ni catálogo de EDSuite Web, sólo el portal y su propia sesión.
 */
export function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
